/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SugestionListAliases {
  APPOINTMENT_SUGGESTION_CARD_0 = 'appointment-suggestion-card-0',
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_SORT = 'autocomplete-sort',
  BUTTON_CONFIRM = 'button-confirm',
  CARD_SUGGESTION_ITEM = 'card-suggestion-item',
  CHECKBOX_ONLY_TELECONSULTATION = 'checkbox-only-teleconsultation',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_SUGGESTION_GROUPS = 'deck-suggestion-groups',
  DECK_SUGGESTION_ITEMS = 'deck-suggestion-items',
  FIELD_0 = 'field-0',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_SORT = 'field-sort',
  FIELD_TELECONSULTATION = 'field-teleconsultation',
  FILTER_SUGGESTION_TIMES = 'filter-suggestion-times',
  FORM_0 = 'form-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_0 = 'layout-0',
  LOADER_FILTER = 'loader-filter',
  MAPPER_0 = 'mapper-0',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_SORT = 'mapper-sort',
  PANEL_0 = 'panel-0',
  PANEL_DATE = 'panel-date',
  PANEL_FILTER = 'panel-filter',
  PANEL_FILTERS = 'panel-filters',
  PANEL_LOAD_CONTENT = 'panel-load-content',
  PANEL_SUGGESTIONS = 'panel-suggestions',
  PANEL_SUGGESTIONS_CONTENT = 'panel-suggestions-content',
  PANEL_WEEK_DAYS = 'panel-week-days',
  SEGMENTED_CONTROL_WEEK_DAYS = 'segmented-control-week-days',
  SUGGESTION_LAYOUT = 'suggestion-layout',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
}
export { SugestionListAliases };
